export default __webpack_public_path__ + "static/media/occitania.d82d54af.svg";